import { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell, { inputCls, labelCls } from "./AuthShell";
import { http, formatApiErrorDetail } from "@/lib/api";
import { useSeo } from "@/lib/seo";

export default function Forgot() {
  useSeo({ title: "Reset Password | Infant Sleep Consultant Near Me Education Center", noindex: true });
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await http.post("/auth/forgot-password", { email }); } catch (e2) {}
    setSent(true); setBusy(false);
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your email and we'll send a secure reset link."
      footer={<Link to="/login" className="text-[#C2836B] hover:underline">Back to sign in</Link>}>
      {sent ? (
        <p data-testid="forgot-confirm" className="text-[#A39E98] text-[15px] leading-relaxed">If that email is registered, a reset link has been sent. Please check your inbox.</p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className={labelCls}>Email</label>
            <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
          </div>
          <button data-testid="forgot-submit" disabled={busy} className="btn-clay w-full py-3 rounded-full text-sm disabled:opacity-60">{busy ? "Sending…" : "Send reset link"}</button>
        </form>
      )}
    </AuthShell>
  );
}
